var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.92 175.91",
    style: {
      enableBackground: "new 0 0 175.92 175.91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 82.0082,
    cy: 211.31,
    r: 226.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2602,
    style: {
      stopColor: "#36B649"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7602,
    style: {
      stopColor: "#57C965"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.92,139.78c0,19.96-16.17,36.13-36.13,36.13H36.14C16.18,175.92,0,159.74,0,139.78V36.13 C0,16.17,16.18,0,36.14,0h103.65c19.96,0,36.13,16.18,36.13,36.14V139.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 63.6891,
    cy: 156.4397,
    r: 138.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2194,
    style: {
      stopColor: "#E7E7E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    style: {
      stopColor: "#FCFCFC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.15,23.1c-35.48,0-64.25,28.76-64.25,64.25c0,11.99,3.29,23.2,9.01,32.8l-8.1,32.66l32.2-9.27 c9.23,5.12,19.84,8.05,31.14,8.05c35.49,0,64.25-28.77,64.25-64.25C153.39,51.86,124.63,23.1,89.15,23.1z M89.87,140.93 c-11.22,0-21.63-3.48-30.22-9.4l-18.33,5.28l4.69-18.89c-5.97-8.62-9.47-19.07-9.47-30.33c0-29.46,23.88-53.34,53.34-53.34 c29.46,0,53.34,23.88,53.34,53.34C143.21,117.05,119.33,140.93,89.87,140.93z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 65.1558,
    cy: 127.3569,
    r: 62.1087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2194,
    style: {
      stopColor: "#E7E7E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.9,82.26c0.75-0.86,1.49-1.71,2.23-2.57c1.25-1.45,3.13-2.85,3.22-4.94c0.09-2.01-0.62-4.01-1.33-5.83 c-0.46-1.17-0.92-2.34-1.38-3.52c-0.81-2.14-1.86-5.13-3.04-6.38c-1.6-1.69-4.33-2.05-6.5-1.01c0,0-12.61,6.06-8.72,18.18 c0,0,7.51,34.18,45.34,41.21c0,0,13.57,1.94,17.21-6.3c0.79-1.78,1.32-4.28,1.19-6.21c-0.13-1.88-1.45-3.12-3-4.01 c-1.99-1.14-3.77-2.21-6.04-3.33c-1.97-0.97-4.24-2.4-6.5-1.78c-1.66,0.46-2.86,1.98-3.98,3.19c-1.47,1.56-2.97,3.09-4.46,4.64 C97.15,103.59,77.99,96.56,72.9,82.26z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.17ca434e2f993ce6b5638d4ef8ea9c9b.svg";
export { ForwardRef as ReactComponent };